import { render, staticRenderFns } from "./media-section.vue?vue&type=template&id=07dd74f2&scoped=true&"
import script from "./media-section.vue?vue&type=script&lang=js&"
export * from "./media-section.vue?vue&type=script&lang=js&"
import style0 from "./media-section.vue?vue&type=style&index=0&id=07dd74f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd74f2",
  null
  
)

export default component.exports